/** Common ground (PR 7): is the LinkedIn profile read the sender's own? Pure. */
/** "Strümpfler" = "Struempfler" = "strumpfler": lower case, no accents, umlauts folded. */
const nameParts = (v: string) =>
  v
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/(a|o|u)e/g, '$1')
    .split(/[^a-z]+/)
    .filter(Boolean);
const profileSlug = (url: string) => url.trim().replace(/^https?:\/\/(www\.)?/i, '').split(/[?#]/, 1)[0].replace(/\/+$/, '').toLowerCase();

/**
 * Is the profile read the sender's? By the LinkedIn link when the sender has one, else every part
 * of the sender's name must be in the profile's name (CodeRabbit, PR #736: any "Sofia" passed).
 */
export function isSendersProfile(sender: { name: string; linkedinUrl?: string | null }, read: { name?: string | null; publicUrl?: string | null }) {
  if (!read.name) return false;
  // A stored link decides alone: no URL read, no match (CodeRabbit, PR #736 — fail closed).
  if (sender.linkedinUrl) return Boolean(read.publicUrl) && profileSlug(sender.linkedinUrl) === profileSlug(read.publicUrl as string);
  const theirs = new Set(nameParts(read.name));
  const mine = nameParts(sender.name);
  return mine.length > 0 && mine.every((p) => theirs.has(p));
}
